import { create } from "zustand";

const useCountStore = create((set) => ({
  count: 1,
  setCount: (newCount) => set({ count: newCount }),
}));

export default useCountStore;
